import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=7f0bd4dd&scoped=true&"
import script from "./practice.vue?vue&type=script&lang=js&"
export * from "./practice.vue?vue&type=script&lang=js&"
import style0 from "./practice.vue?vue&type=style&index=0&id=7f0bd4dd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0bd4dd",
  null
  
)

export default component.exports